export default "__VITE_ASSET__H5f93NCB__"